import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=17059fc8"
import script from "./Collapsible.ts?vue&type=script&lang=js&external"
export * from "./Collapsible.ts?vue&type=script&lang=js&external"
import style0 from "./Collapsible.scss?vue&type=style&index=0&prod&module=true&lang=scss&external"
import style1 from "./CollapsibleGlobal.scss?global?vue&type=style&index=1&prod&lang=css&external"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports